import EditorJS, { OutputData } from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import ImageTool from "../classes/editorjs/ImageTool";
import BreakLineTool from "../classes/editorjs/BreakLineTool";
import React, { useEffect, useState } from "react";
import styles from "./RichTextArea.module.scss";

type Props = {
  richTextData?: OutputData;
  setArticle: (outputData: OutputData) => void;
  changeArticle: () => void;
};
const RichTextArea: React.FC<Props> = ({
  richTextData,
  setArticle,
  changeArticle,
}) => {
  const [editor, setEditor] = useState<EditorJS>();

  // mount
  useEffect(() => {
    setEditor(initEditor(richTextData));
  }, []);

  // unmount
  useEffect(() => {
    return () => {
      if (editor) {
        editor.destroy();
      }
    };
  }, [editor]);

  const initEditor = (richTextData?: OutputData) => {
    const editor = new EditorJS({
      holder: "editor_area",
      data: richTextData,
      tools: {
        // EditorJS plugins can be added here, the key will become the "type" field.
        header: {
          class: Header,
          config: {
            placeholder: "",
            levels: [2, 3],
            defaultLevel: 2,
          },
        },
        list: List,
        table: Table,
        image: {
          class: ImageTool,
          config: {
            save: () =>
              editor
                .save()
                .then((outputData: OutputData) => {
                  setArticle(outputData);
                  changeArticle();
                })
                .catch(() => {}),
          },
        },
        breakLine: BreakLineTool,
      },
      inlineToolbar: true,
      onReady: () => {
        editor
          .save()
          .then((outputData: OutputData) => {
            setArticle(outputData);
          })
          .catch(() => {});

        const inlineTool = document.getElementsByClassName(
          "ce-popover__container"
        );
        inlineTool[0]?.classList.add(`${styles["inline-tool"]}`);
      },
      onChange: () => {
        editor
          .save()
          .then((outputData: OutputData) => {
            setArticle(outputData);
            changeArticle();
          })
          .catch(() => {});
      },
    });
    return editor;
  };

  return (
    <>
      <div id="editor_area" className={styles["editor-area"]}></div>
    </>
  );
};

export default RichTextArea;
